import { temAcesso } from '@/shared/auth/temAcesso'
import itensDespesasRotas from '../itensDespesas/ItensDespesasRotas'
import RateiosRotas from '../rateios/RateiosRotas'

const Despesas = () => import('./Despesas.vue') 
const Despesa = () => import('./Despesa.vue') 
const InserirAtualizarDespesaForm = () => import('./InserirAtualizarDespesaForm.vue')
const BuscarMovimentoCompra = () => import('./BuscarMovimentoCompra.vue')

export default {
    path: 'despesas',
    name: 'DespesasGerais_Requisitantes_Despesas',
    component: Despesas,
    beforeEnter(to, from, next) {
        if (temAcesso('DESP-GERAIS-REQ-00')) {
            next();
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'DespesasGerais_Requisitantes_Despesas_Inserir',
            component: InserirAtualizarDespesaForm,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-REQ-01')) {
                    next();
                }
            }
        },
        {
            path: 'buscarcompra',
            name: 'DespesasGerais_Requisitantes_Despesas_BuscarCompra',
            component: BuscarMovimentoCompra,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-REQ-07')) {
                    next();
                }
            }
        },
        {
            path: ':despesaId/atualizar',
            name: 'DespesasGerais_Requisitantes_Despesas_Atualizar',
            component: InserirAtualizarDespesaForm,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-REQ-02')) {
                    next();
                }
            }
        }, 
        {
            path: ':despesaId',
            name: 'DespesasGerais_Requisitantes_Despesas_Detalhar',
            component: Despesa,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-REQ-00')) {
                    next()
                }
            },
            children: [itensDespesasRotas, 
                // RateiosRotas
            ]
        },
    ]
}